'use strict';

var MarketsFilterByMarketFactory = function MarketsFilterByMarketFactory(DataFilter) {
  function MarketsFilterByMarket() {
    DataFilter.call(this, ['market-dashboard', 'fim-dashboard'], 'markets-and-poses', 2);
  }
  MarketsFilterByMarket.prototype = Object.create(DataFilter.prototype);
  MarketsFilterByMarket.prototype.filter = function (data, range) {
    range = range[0];
    return DataFilter.prototype.filter(data, range.market, 'market');
  };
  return MarketsFilterByMarket;
};
MarketsFilterByMarketFactory.$inject = ['DataFilterFactory'];
module.exports = MarketsFilterByMarketFactory;